import {
  Create,
  SimpleForm,
  NumberInput,
  SelectInput,
  usePermissions,
  useRedirect,
  useNotify,
} from "react-admin";
import { useEffect, useState } from "react";
import { Button, TextField, Tabs, Tab, Box } from "@mui/material";
import { apiUrl } from "../apiendpoint";
import { useTheme } from "@mui/material/styles";

import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import {
  Paper,
  Typography,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
 
} from "@mui/material";

import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import IconButton from "@mui/material/IconButton";

class UploadAdapter {
  constructor(loader, uploadUrl) {
    this.loader = loader;
    this.uploadUrl = uploadUrl;
  }

  upload() {
    return this.loader.file.then(file =>
      new Promise((resolve, reject) => {
        const data = new FormData();
        data.append("file", file);
        data.append("question_id", this.questionId);
        fetch(`${apiUrl}uploadUrls`, {
          method: "POST",
          body: data,
          headers:{
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          }
        })
          .then(res => res.json())
          .then(res => resolve({ default: res.url }))
          .catch(err => reject(err));
      })
    );
  }

  abort() {}
}

const RichTextInput = ({ value, onChange, label }) => {
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";
  const notify = useNotify();
  const redirect = useRedirect();
  

  return (
    <div style={{ marginTop: 10 }}>
      <label>{label}</label>

      <div style={{ borderRadius: "4px", minHeight: "150px", width: "800px" }}>
        <CKEditor
          editor={ClassicEditor}
          data={value || ""}
          onReady={(editor) => {
            editor.ui.view.editable.element.style.color = isDark ? "#fff" : "#000";
            editor.ui.view.editable.element.style.padding = "10px";
            editor.ui.view.editable.element.style.minHeight = "200px";
            

            editor.plugins.get("FileRepository").createUploadAdapter = (loader) =>
              new UploadAdapter(loader, `${apiUrl}uploads`);
          }}
          config={{
            placeholder: "Type your question here...",
            toolbar: [
              "heading",
              "|",
              "bold",
              "italic",
              "link",
              "bulletedList",
              "numberedList",
              "blockQuote",
              "imageUpload",
              "undo",
              "redo",
              "insertTable",
            ],
          }}
          onChange={(event, editor) => onChange(editor.getData())}
        />
      </div>
    </div>
  );
};

const QuestionCreate = () => {
   const { permissions = [] } = usePermissions();
   const redirect = useRedirect();
   const notify = useNotify();
  const [tab, setTab] = useState(0);
  const [categories, setCategories] = useState([]);
  const [categoryBlocks, setCategoryBlocks] = useState([
    { category: "", subcategory: "" },
  ]);

  const [questions, setQuestions] = useState([
    {
      title: "",
      marks: 0,
      difficulty: "easy",
      options: [{ id: "opt1", text: "" }],
      correct: "",
    },
  ]);

  useEffect(() => {
    const token = localStorage.getItem("access_token");
    fetch(`${apiUrl}categories`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => res.json())
      .then((data) => setCategories(data))
      .catch(() => console.error("Error loading categories"));
  }, []);
    if (
      !(
        permissions.includes("assessments.create") ||
        permissions.includes("assessments.*") ||
        permissions.includes("*")
      )
    ) {
      return null;
    }


  const grouped = categories.reduce((acc, item) => {
    if (!acc[item.category_name]) {
      acc[item.category_name] = [];
    }
    acc[item.category_name].push(item);
    return acc;
  }, {});

  const addQuestion = () => {
    setQuestions([
      ...questions,
      {
        title: "",
        marks: 0,
        difficulty: "easy",
        options: [{ id: "opt1", text: "" }],
        correct: "",
      },
    ]);
  };

  const updateQuestion = (index, field, value) => {
    const updated = [...questions];
    updated[index][field] = value;
    setQuestions(updated);
  };

  const addOption = (qIndex) => {
    const updated = [...questions];
    updated[qIndex].options.push({
      id: `opt${updated[qIndex].options.length + 1}`,
      text: "",
    });
    setQuestions(updated);
  };

  const updateOption = (qIndex, optIndex, value) => {
    const updated = [...questions];
    updated[qIndex].options[optIndex].text = value;
    setQuestions(updated);
  };

  const handleSubmit = async () => {
  try {
    const categoryIds = categoryBlocks
      .map((b) => Number(b.subcategory))
      .filter(Boolean);

    const token = localStorage.getItem("access_token");

    for (let q of questions) {
      const payload = {
        title: q.title,
        assessment_category_ids: categoryIds,
        difficulty_level: q.difficulty,
        question_data: {
          type: "mcq",
          question_text: q.title,
          marks: q.marks || 0,
          options: q.options.map((o) => o.text),
          answer: {
            correct_option: q.correct,
          },
        },
      };

      await fetch(`${apiUrl}questions`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });
    }

    notify("Questions created successfully 🎉", {
      type: "success",
    });

    redirect("/questions");
  } catch (err) {
    console.error(err);
    alert("Error creating questions");
  }
};

// ✅ FIXED navigation
const goToQuestions = () => {
  const hasCategory = categoryBlocks.some((b) => b.subcategory);

  if (!hasCategory) {
    alert("Please select category & subcategory first");
    return;
  }

  setTab(1);
};
  

  return (
  <Create title="Create Assessment"
  >
    <SimpleForm onSubmit={handleSubmit}>
      
      {/* TABS HEADER */}
      <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 2 }}>
        <Tabs
          value={tab}
          onChange={(e, val) => setTab(val)}
          textColor="primary"
          indicatorColor="primary"
        >
          <Tab label="CATEGORY" />
          <Tab label="QUESTIONS" />
        </Tabs>
      </Box>

      {/* CONTENT */}
      <Box sx={{ maxWidth: "1200px" }}>
{tab === 0 && (
  <Box sx={{ maxWidth: "900px", mt: 4 }}>
    
    {/* HEADER */}
    <Typography
      variant="h5"
      fontWeight={700}
      mb={4}
    >
      Select Categories
    </Typography>

    {/* ROWS */}
    {categoryBlocks.map((block, index) => (
      <Box
        key={index}
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 2,
          mb: 3,
        }}
      >
        {/* CATEGORY */}
        <FormControl sx={{ minWidth: 250 }}>
          <InputLabel>Category</InputLabel>

          <Select
            value={block.category}
            label="Category"
            onChange={(e) => {
              const updated = [...categoryBlocks];
              updated[index].category = e.target.value;
              updated[index].subcategory = "";
              setCategoryBlocks(updated);
            }}
          >
            {Object.keys(grouped).map((cat) => (
              <MenuItem key={cat} value={cat}>
                {cat}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {/* SUBCATEGORY */}
        <FormControl sx={{ minWidth: 250 }}>
          <InputLabel>Subcategory</InputLabel>

          <Select
            value={block.subcategory}
            label="Subcategory"
            onChange={(e) => {
              const updated = [...categoryBlocks];
              updated[index].subcategory = e.target.value;
              setCategoryBlocks(updated);
            }}
          >
            {(grouped[block.category] || []).map((sub) => (
              <MenuItem
                key={sub.id}
                value={sub.id}
              >
                {sub.subcategory_name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {/* ADD BUTTON ONLY LAST ROW */}
{index === categoryBlocks.length - 1 && (
  <IconButton
    color="primary"
    onClick={() =>
      setCategoryBlocks([
        ...categoryBlocks,
        {
          category: "",
          subcategory: "",
        },
      ])
    }
  >
    <AddIcon />
  </IconButton>
)}

{/* DELETE BUTTON */}
{categoryBlocks.length > 1 && (
  <IconButton
    color="error"
    onClick={() => {
      const updated = categoryBlocks.filter(
        (_, index) => index !== index
      );

      setCategoryBlocks(updated);
    }}
  >
    <DeleteIcon fontSize="small" />
  </IconButton>
)}
      </Box>
    ))}
  </Box>
)}        {/* QUESTIONS TAB */}
        {tab === 1 && (
          <Box>
            <Button
              onClick={() => setTab(0)}
              sx={{ mb: 2 }}
            >
              ← BACK TO CATEGORY
            </Button>

            {questions.map((q, qIndex) => (
              <Box
                key={qIndex}
                sx={{
                  
                  mb: 4,
                  p: 2,
                  border: "1px solid #333",
                  borderRadius: "8px",
                }}
              >
                

                <RichTextInput
                  label={`Question ${qIndex + 1}`}
                  value={q.title}
                  onChange={(val) =>
                    updateQuestion(qIndex, "title", val)
                  }
                />
                 
                <Box
                      sx={{
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr", // equal columns
                        gap: 4,
                        mt: 2,
                        display: "flex",
                        justifyContent: "space-between",
                        maxWidth: "600px",
                      }}
                    >
                  <NumberInput
                        source={`marks-${qIndex}`}
                        label="Marks"
                        fullWidth
                        sx={{
                          width: "100%",
                          "& .MuiInputBase-root": {
                            height: "60px",   
                          },
                        }}
                        onChange={(e) =>
                          updateQuestion(qIndex, "marks", Number(e.target.value))
                        }
                      />

                      <SelectInput
                        source={`difficulty-${qIndex}`}
                        label="Difficulty"
                        choices={[
                          { id: "easy", name: "Easy" },
                          { id: "medium", name: "Medium" },
                          { id: "hard", name: "Hard" },
                        ]}
                        fullWidth
                        sx={{
                          width: "100%",
                          ml: "auto",
                          "& .MuiInputBase-root": {
                            height: "60px",   
                            
                          },
                        }}
                        onChange={(e) =>
                          updateQuestion(qIndex, "difficulty", e.target.value)
                        }
                      />

                  
                </Box>

                <h2 style={{ marginTop: 20 }}>Options</h2>

                {q.options.map((opt, optIndex) => (
                  <Box
                    key={opt.id}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 2,
                      mb: 1,
                    }}
                  >
                    <TextField
                      label={`Option ${optIndex + 1}`}
                      value={opt.text}
                      fullWidth
                      onChange={(e) =>
                        updateOption(qIndex, optIndex, e.target.value)
                      }
                    />

                    <input
                      type="radio"
                      name={`correct-${qIndex}`}
                      value={opt.text}
                      onChange={(e) =>
                        updateQuestion(qIndex, "correct", e.target.value)
                      }
                    />
                    <span>Correct</span>
                  </Box>
                ))}

                <Button onClick={() => addOption(qIndex)}>
                  ADD OPTION
                </Button>
              </Box>
            ))}

            <Button
              variant="contained"
              onClick={addQuestion}
            >
              + ADD QUESTION
            </Button>
          </Box>
        )}

      </Box>
    </SimpleForm>
  </Create>
)};
export default QuestionCreate;